import {Component, OnInit, Input} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SiteInfosService, Recap, ApiService, WindowRefService, TrackingService} from '@app/core';
import {TranslateService} from '@ngx-translate/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from "@angular/router";
const routes = {
    //    saveResa: '/saveresa',
    saveCard: '/savecard',
};
const GTMCheckoutProcess = {
    step_3: 3,
    step_4 : 4,
    payment_method: 'Credit-card'
}
@Component({
    selector: 'app-card-form',
    templateUrl: './card-form.component.html',
    styleUrls: ['./card-form.component.scss']
})


export class CardFormComponent implements OnInit {
    private readonly _ROUTE_VIEWRESA = '/checkprice/viewresa';
    @Input() ruid: string;
    @Input() recapModel: Recap;
    infos: {textBtnSave: string, submitted: boolean} = {textBtnSave: 'reserver', submitted: false} ;

    userForm: FormGroup;


    stepNext: boolean = false;

    constructor(private router: Router, private apiService: ApiService, private fb: FormBuilder, private siteInfosService: SiteInfosService, private modalService: NgbModal, private winRef: WindowRefService, public translate: TranslateService,private trackingService: TrackingService) {
    }

    ngOnInit() {
    }

    save(data: {status: boolean, cardForm: FormGroup}) {
        if (data.status) {
            this.recapModel.setCart(data.cardForm.value);
            let params = {uid: this.ruid, card: data.cardForm.value};
            this.infos.submitted = true;
            this.trackingService.chekoutProcess(GTMCheckoutProcess.step_3,GTMCheckoutProcess.payment_method);
            this.apiService.post(routes.saveCard, params).subscribe(
                rep => {
                    if (rep.status === 1) {
                        this._redirectToViewResa();
                        this.trackingService.chekoutProcess(GTMCheckoutProcess.step_4,null);
                    } else {
                        this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                            alert(res); console.log(res);
                        })
                    }
                    this.infos.submitted = false;
                },
                err => {
                    console.log('Error', err);
                    this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                        alert(res); console.log(res);
                    })
                    this.infos.submitted = false;
                }
            );
        }
        //        console.log({rooms: this.recapModel.getRooms(), user: this.userForm.value, uid: this.uid, cart: this.cartForm.value})
    }


    private _redirectToViewResa(): void {
        this.router.navigate([this._ROUTE_VIEWRESA, this.ruid]);
    }
}
